  <p>
  @for (crumb of breadcrumbs(); track crumb) {
    @if (!crumb.isCurrent) {
      <a [routerLink]="crumb.url">
        {{ crumb.label }}
      </a>
      <motif-icon class="breadcrumb-separator" [iconFunction]="separatorIcon"></motif-icon>
    } @else {
      <span class="breadcrumb-current">
        {{ crumb.label }}
      </span>
    }
  }
</p>